import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=e5429d88&"
import script from "./transfer.ts?vue&type=script&lang=js&"
export * from "./transfer.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports